import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FilteringService } from 'src/app/services/filtering.service';
import { RMO_ClientMapping, RMO_ClientMeta } from '../../models/rentManager';
import { RentmanPropertyMappingModalComponent } from '../rentman-property-mapping-modal/rentman-property-mapping-modal.component'
import { IntegrationsService } from '../../services/integrations.service';

@Component({
  selector: 'app-rentman-integration-pane',
  templateUrl: './rentman-integration-pane.component.html',
  styleUrls: ['./rentman-integration-pane.component.less']

})
export class RentmanIntegrationPaneComponent implements OnInit, OnDestroy {

  @Input() riqClientId: number;
  connectionFailure: boolean = false;
  connectedDate: Date = new Date();
  transferTimestamp: Date = new Date();

  clientMeta: RMO_ClientMeta;
  clientMapping: RMO_ClientMapping;
  isConnected: boolean = false;
  
  $clientMappingSub: Subscription;
  $clientMetaSub: Subscription;
  $clientSaveMappingSub: Subscription;

  constructor(public modalService: NgbModal, public integrations: IntegrationsService, public toast: ToastrService, public filtering: FilteringService) { }
  ngOnDestroy(): void {
    this.$clientMappingSub.unsubscribe();
    if(this.$clientMetaSub) this.$clientMetaSub.unsubscribe();
    if(this.$clientSaveMappingSub) this.$clientSaveMappingSub.unsubscribe();
    this.clientMapping = null;
  }

  ngOnInit() {
    this.clientMapping = new RMO_ClientMapping();
    this.$clientMappingSub = this.integrations.GetRMOClientMapping(this.riqClientId).subscribe(res => {
      //IF we have an existing mapping, set it and the isConnected so we can control UI flow accordingly
      if(res) {
        this.clientMapping = res;
        this.isConnected = true;
        //if we have a clientmapping in the system, we need to fetch the clientmeta
        this.$clientMetaSub = this.integrations.GetRMOClientMeta(this.riqClientId).subscribe((res: RMO_ClientMeta) => {
          this.clientMeta = res;
        },
        err => {  },
        () => {})
      }

    },
    err => { this.toast.error('Error fetching RMO Client mapping!', '', { closeButton: true, disableTimeOut: true }) },
    () => {  })
  }

  connectRentManager(): void {
    console.log('CONNECTING: ', this.clientMapping);
    this.saveClientMapping();
  }

  public get connectButtonText() : string {
    if(this.connectionFailure) return "Reconnect";
    if(this.isConnected) return "Connected";
    else return "Connect";
  }

  mapProperties(): void {
    const modality = this.modalService.open(RentmanPropertyMappingModalComponent, { centered: true, size: 'xl' });
    modality.componentInstance.name = "mapProps";
    modality.componentInstance.corpId = this.clientMapping.corpId;
    modality.componentInstance.riqClientId = this.riqClientId;
  }

  saveClientMapping(): void {
    this.$clientSaveMappingSub = this.integrations.SaveRMOClientMapping(this.clientMapping.corpId, this.riqClientId).subscribe(res => {
      if(res) {
        this.clientMapping.clientId = this.riqClientId;
        this.isConnected = true;
        this.toast.success(`RIQ Client mapped to RentManager Client ${this.clientMapping.corpId}`);
      } 
    },
    err => {
      if(err.status == 409) {
        this.toast.error(`A mapping already exists with Id: ${this.clientMapping.corpId}`);
      }
      else this.toast.error(`Error mapping client!`, '', { closeButton: true, disableTimeOut: true })
    })
  }

}
